export default __webpack_public_path__ + "static/media/payfast-logo.906855d0.png";